import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, selectAktuellerUser } from 'core/features/auth/authSlice';
import PasswortAendernDialog from 'core/components/PasswortAendernDialog';

const buttonKlasse =
  'rounded-lg border border-line px-3 py-1.5 text-sm font-medium text-ink-muted transition-colors hover:bg-ink/5 hover:text-ink';

/**
 * Zeigt den angemeldeten Nutzer samt Passwort-aendern- und Abmelden-Button.
 * `variant="kompakt"` fuer die Sidebar (untereinander), Standard fuer die
 * Kopfzeile (nebeneinander).
 */
export default function UserMenu({ variant = 'standard' }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectAktuellerUser);
  const [dialogOffen, setDialogOffen] = useState(false);

  const abmelden = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  const kompakt = variant === 'kompakt';

  return (
    <div className={kompakt ? 'flex flex-col gap-2' : 'flex items-center gap-3'}>
      {/* Am Handy (Standard-Variante) Platz sparen: nur die Buttons zeigen. */}
      <span className={`text-sm text-ink-soft ${kompakt ? '' : 'hidden sm:inline'}`}>
        Angemeldet als <span className="font-medium text-ink">{user?.username}</span>
      </span>
      <button
        type="button"
        onClick={() => setDialogOffen(true)}
        title="Login-Passwort ändern"
        className={buttonKlasse}
      >
        Passwort ändern
      </button>
      <button type="button" onClick={abmelden} className={buttonKlasse}>
        Abmelden
      </button>
      {dialogOffen && <PasswortAendernDialog onClose={() => setDialogOffen(false)} />}
    </div>
  );
}
